import { Alert } from '@valid-eval/shared-react-components';

const Errors = ({ errors, alertClasses }) => {
  if (errors) {
    return (
      <Alert
        variant="danger"
        className={typeof alertClasses === 'string' ? alertClasses : alertClasses?.alert}
      >
        {errors.length === 1 ? (
          typeof errors[0] === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: errors[0] }} />
          ) : (
            errors[0]
          )
        ) : (
          <ul>
            {errors.map((error) => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        )}
      </Alert>
    );
  } else {
    return null;
  }
};

export default Errors;
